/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add service note
 */
export const AddServiceNoteBody = zod.object({
  title: zod.string(),
  content: zod.string(),
});

export const AddServiceNoteResponse = zod.int().describe("Note identity.");

/**
 * @summary Edit service note
 */
export const EditServiceNoteBody = zod.object({
  title: zod.string(),
  content: zod.string(),
});

export const EditServiceNoteResponse = zod.void();

/**
 * @summary Remove service note
 */
export const RemoveServiceNoteResponse = zod.void();
